import { useState, useRequestHeader, type Ref } from '#imports'
import { isKnownCrawler } from '../utils/isKnownCrawler'

/** Server UA verdict, hydrated so a JS-executing crawler does not re-read the header on the client. */
export function useIsKnownCrawler(): Ref<boolean> {
    return useState<boolean>('isKnownCrawler', () =>
        isKnownCrawler(useRequestHeader('user-agent'))
    )
}
